import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";

export default class IssueReportingClient {

    constructor(apiHost) {
        this.apiHost = apiHost;
    }

    createTicket = async (issue_data) => {
        
        const path = `/prod`;
        let response =  await ApiCallerClient.callApi({
            "endpoint": {
                "hostName": this.apiHost,
                "httpMethod": ApiMethod.POST,
                "path": path
            },
            "body": JSON.stringify({"bug_report_data": JSON.stringify(issue_data)})
        });
        return;
    }
}